  const translations = {
    es: {
      title: "Gestión de Disponibilidad",
      selectService: "Servicio",
      selectPlaceholder: "Selecciona un servicio",
      selectedDay: "Día seleccionado",
      startTime: "Hora de inicio",
      endTime: "Hora de fin",
      add: "Agregar horario",
      remove: "Eliminar",
      save: "Guardar Disponibilidad",
      completeFields: "Por favor completa todos los campos.",
      switchLang: "Cambiar a Inglés",
      currentAvailability: "Disponibilidades Guardadas",
      pending: "Horarios por confirmar",
      savedOk: "Disponibilidad guardada correctamente.",
      networkErr: "Error de conexión.",
      serverErr: "Error al guardar.",
      pastDateErr: "No puedes seleccionar fechas pasadas.",
      timeOrderErr: "La hora final debe ser mayor que la inicial.",
      duplicateErr: "Este horario ya está registrado.",
      overlapErr: "Se superpone con otro horario.",
      noServiceErr: "Selecciona un servicio antes de continuar.",
      detailsTitle: "Detalles del error",
      reloadSaved: "Actualizando...",
      noAvailabilities: "No hay disponibilidades guardadas",
      addNewAvailability: "Agregar nueva disponibilidad",
      instructions: "Selecciona un servicio, fecha y horario",
      timeRange: "Rango horario",
      actions: "Acciones",
      edit: "Editar",
      cancelEdit: "Cancelar edición",
      update: "Actualizar",
      deleteConfirm: "¿Eliminar esta disponibilidad?",
      deleteSuccess: "Disponibilidad eliminada correctamente.",
      errorbookingactive:"Error esta disponibilidad tiene reservas activas",
      errorbookingproccess:"Error esta disponibilidad tiene una transacción en proceso"
      
    },
    en: {
      title: "Availability Management",
      selectService: "Service",
      selectPlaceholder: "Select a service",
      selectedDay: "Selected day",
      startTime: "Start time",
      endTime: "End time",
      add: "Add schedule",
      remove: "Remove",
      save: "Save Availability",
      completeFields: "Please complete all fields.",
      switchLang: "Switch to Spanish",
      currentAvailability: "Saved Availabilities",
      pending: "Pending confirmation",
      savedOk: "Availability saved successfully.",
      networkErr: "Connection error.",
      serverErr: "Error saving data.",
      pastDateErr: "Cannot select past dates.",
      timeOrderErr: "End time must be after start time.",
      duplicateErr: "This schedule already exists.",
      overlapErr: "Overlaps with another schedule.",
      noServiceErr: "Select a service first.",
      detailsTitle: "Error details",
      reloadSaved: "Refreshing...",
      noAvailabilities: "No saved availabilities",
      addNewAvailability: "Add new availability",
      instructions: "Select a service, date and time range",
      timeRange: "Time range",
      actions: "Actions",
      edit: "Edit",
      cancelEdit: "Cancel edit",
      update: "Update",
      deleteConfirm: "Delete this availability?",
      deleteSuccess: "Availability deleted successfully.",
      errorbookingactive:"Error this available has bookings active",
      errorbookingproccess:"Error this available has a booking incoming"
    },
  };
export default  translations
 